import { Component, Emit, Provide, Ref, Vue } from 'vue-property-decorator'
import BillingModalInvoicesCrudCardComponent from '@/modules/billing-module/components/modal/invoices/crud/components/card/billing-modal-invoices-crud-card.vue'
import BillingModalInvoicesCrudFormComponent from '@/modules/billing-module/components/modal/invoices/crud/components/form/billing-modal-invoices-crud-form.vue'
import BillingModalInvoicesCrudGridComponent from '@/modules/billing-module/components/modal/invoices/crud/components/grid/billing-modal-invoices-crud-grid.vue'
import BillingModalInvoicesCrudActionsComponent from '@/modules/billing-module/components/modal/invoices/crud/components/actions/billing-modal-invoices-crud-actions.vue'
import { BModal } from 'bootstrap-vue'
import {
    BillingModalInvoicesCrudParams,
    initialInvoiceModalState,
    InvoiceModalState
} from '@/modules/billing-module/components/modal/invoices/crud/billing-modal-invoices-crud.model'
import { InvoiceStatus } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { billingCommonInvoiceService } from '@/api/services/billing/common-invoice/billing-common-invoice.service'
import { Nullable } from '@/shared/types/app.types'
import { cloneDeep } from 'lodash'
import { store } from '@/store/store'
import { PromiseUtils } from '@/shared/util/promise-utils'
import axios from 'axios'

@Component({
    components: {
        BillingModalInvoicesCrudCardComponent,
        BillingModalInvoicesCrudFormComponent,
        BillingModalInvoicesCrudGridComponent,
        BillingModalInvoicesCrudActionsComponent
    }
})
export default class BillingModalInvoicesCrud extends Vue {
    @Ref() readonly invoiceModal!: BModal

    @Provide() externalValidator = this.$validator

    @Emit()
    refresh(): void {
        // emits an event
    }

    state: InvoiceModalState
    constructor() {
        super()
        this.state = initialInvoiceModalState()
    }

    /// COMPUTED ///

    get modalTitle(): string {
        return this.state.invoice
            ? this.$tc('accounting.action.updateInvoice')
            : this.$tc('accounting.action.generateInvoice')
    }
    get visibleInvoiceModalForm(): boolean {
        return !!this.state.invoice
    }
    get invoiceStatusCode(): Nullable<InvoiceStatus> {
        return this.state.invoice?.status.code
    }

    /// MODAL ///

    show(params: BillingModalInvoicesCrudParams): void {
        this.state = initialInvoiceModalState()

        const { invoice, deliveryNotes } = params
        if (deliveryNotes) {
            this.state.deliveryNotes = cloneDeep(deliveryNotes)
        }
        if (invoice) {
            this.state.invoice = cloneDeep(invoice)
        }
        this.invoiceModal.show()
    }
    hide(): void {
        this.invoiceModal.hide()
    }

    /// EVENT HANDLERS ///

    private async _reloadInvoice(invoiceId: number): Promise<boolean> {
        this.state.source = axios.CancelToken.source()
        const response =
            await PromiseUtils.toCallSecure(
                billingCommonInvoiceService.get(store.state.labId, invoiceId, this.state.source.token))
        if (response !== null) {
            this.state.invoice = response
        }
        return response !== null
    }
    async onRefresh(invoiceId: number): Promise<void> {
        this.state.source?.cancel()
        if (await this._reloadInvoice(invoiceId)) {
            this.refresh()
        }
    }

    onDeliveryNotesCountChanged(count: number): void {
        this.state.invoiceDeliveryNotesCount = count
    }

    async onDeliveryNotesDeleted(): Promise<void> {
        if (this.state.invoice) {
            await this.onRefresh(this.state.invoice.id)
        }

        if (!this.state.invoice && !this.state.deliveryNotes.length) {
            this.hide()
        }
    }
}
